import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import paginationStyle from './paginationComp.module.css';
const PaginationComp = ({
  totalPages,
  currentPage,
  handlePageChange,
  disabled,
}) => {
  return (
    <Box className={paginationStyle.pagination_container}>
      <Pagination
        sx={{
          '& .MuiPaginationItem-root': {
            borderRadius: '8px',
            margin: '4px',
            color: '#475467',
          },
          '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: '#FDE7DA',
            color: '#F37021',
          },
          '& .MuiPaginationItem-root.Mui-selected:hover': {
            backgroundColor: '#FDE7DA',
          },
        }}
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        color="primary"
        disabled={disabled}
      />
    </Box>
  );
};

PaginationComp.propTypes = {
  totalPages: PropTypes.any,
  currentPage: PropTypes.any,
  handlePageChange: PropTypes.any,
  disabled: PropTypes.bool,
};

export default PaginationComp;
